import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import styles from './UploadcareModalUploader.module.css';

const UploadcareModalUploader = ({ isOpen, onClose, onUpload }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  const handleUpload = () => {
    const widget = window.uploadcare.openDialog(null, {
      publicKey: process.env.REACT_APP_UPLOADCARE_PUBLIC_KEY,
      imagesOnly: true,
      crop: '1:1',
      tabs: 'file camera'
    });

    widget.done((fileInfoPromise) => {
      fileInfoPromise.done((fileInfo) => {
        console.log('Uploadcare fileInfo:', fileInfo);
        if (fileInfo && fileInfo.cdnUrl) {
          onUpload(fileInfo.cdnUrl);
          onClose();
        }
      });
    });
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={styles.modal}
            initial={{ y: 50, opacity: 0, scale: 0.95 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 50, opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.3 }}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              className={styles.closeBtn}
              aria-label="Close uploader modal"
            >
              <FiX />
            </button>

            <h2 className={styles.title}>Upload Profile Photo</h2>

            <button
              type="button"
              className={styles.uploadButton}
              onClick={handleUpload}
            >
              Choose Photo
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default UploadcareModalUploader;